// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { UserServiceRequest } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useRejectUserServiceRequest: () => UseMutationResult<
  void,
  string,
  { userServiceRequestCid: ContractId<UserServiceRequest> }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['rejectuserServiceRequest', ledgerApi],
    mutationFn: async ({ userServiceRequestCid }) => {
      return ledgerApi.rejectCredentialUserServiceRequest(userServiceRequestCid);
    },
  });
};

export default useRejectUserServiceRequest;
